module.exports = __webpack_public_path__ + "img/rhythm1.0454275a.png";